import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import OpeningTimes from './OpeningTimes';
import {
  RestaurantPanelStyled,
  TradeShowLogo,
  PanelContent,
  PanelActions,
  RestaurantName,
  SmallAddress,
  SmallAddressWrapper,
  SmallAddressLink,
  StaticMap,
  OpeningStatus,
  MapWrapper
} from './HomePage.style';

export class RestaurantPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openingStatus: false
    };
  }

  componentDidMount() {
    if (!this.state.openingStatus) { // only show restaurant opening button after SSR, it fixed the server timezone issue
      this.setState({openingStatus: true}); //eslint-disable-line
    }
  }

  render() {
    const {
      googleMapUrl,
      headerColor,
      isOpen,
      isOpenForCollectionOrDelivery,
      isOpensInSevenDays,
      openButtonText,
      openingTimesContent,
      renderTradeShowButton,
      restaurant
    } = this.props;
    const {imageLogoUrl, name, address, modes, openingTimes} = restaurant;

    const renderOpeningStatus = this.state.openingStatus && (
      <OpeningStatus
        isOpen={isOpen}
        headerColor={headerColor}
      >
        <FormattedMessage id={openButtonText} />
      </OpeningStatus>
    );

    const renderMap = googleMapUrl && (
      <MapWrapper to="/contact">
        {renderOpeningStatus}
        <StaticMap
          src={googleMapUrl}
          alt={name}
        />
      </MapWrapper>
    );

    const renderOpeningTime = this.state.openingStatus && openingTimes && modes &&
      OpeningTimes({
        isOpenForCollectionOrDelivery,
        openingTimesContent,
        isOpensInSevenDays
      });

    const renderLogo = imageLogoUrl && (
      <TradeShowLogo
        src={`${imageLogoUrl}=s240`}
        alt={restaurant.name}
        data-rw="home-page--restaurant-panel--restaurant-logo"
      />
    );

    return (
      <RestaurantPanelStyled data-rw="home-page--restaurant-panel">
        {renderLogo}
        <div>
          <RestaurantName headerColor={headerColor}>{name}</RestaurantName>
          <SmallAddress data-rw="home-page--restaurant-panel--restaurant-content-address">
            {address.singleLine}
          </SmallAddress>
        </div>
        {renderMap}
        <PanelContent>
          {renderOpeningTime}
          <SmallAddressWrapper headerColor={headerColor}>
            <SmallAddressLink to="/contact">
              <FormattedMessage id="home.restaurant.fullOpeningTime" />
            </SmallAddressLink>
          </SmallAddressWrapper>
        </PanelContent>
        <PanelActions>
          {renderTradeShowButton}
        </PanelActions>
      </RestaurantPanelStyled>
    );
  }
}

RestaurantPanel.propTypes = {
  googleMapUrl: PropTypes.string.isRequired,
  headerColor: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isOpenForCollectionOrDelivery: PropTypes.bool.isRequired,
  isOpensInSevenDays: PropTypes.bool.isRequired,
  openButtonText: PropTypes.string.isRequired,
  openingTimesContent: PropTypes.object.isRequired,
  renderTradeShowButton: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired
};

export default RestaurantPanel;



// WEBPACK FOOTER //
// ./containers/HomePage/RestaurantPanel.js